export default function <T>(data: T) {
    return {
        type: '',
        payload: data,
    }
}
